import { TimeRangePickerProps } from 'antd'
import dayjs from 'dayjs'
import { ColumnFilterItem } from "antd/lib/table/interface";

export const rangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Today', value: [dayjs(), dayjs()] },
  { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
  { label: 'Last week', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Last month', value: [dayjs().add(-31, 'd'), dayjs()] },
]


export const convertSellOfferStatus = (status: string): string => {
  switch (status) {
    case 'in_progress': return 'in progress'
    case 'completed': return 'completed'
    case 'closed': return 'closed'
     default:return status
  }
}

export const statusFilter:ColumnFilterItem[] = [
  {value: 'in_progress', text: 'in progress'},
  {value: 'completed', text: 'completed'},
  {value: 'closed', text: 'closed'},
]

export enum paymentMethod {
  NOVA_WALLET='NOVA Wallet',
  AUTO_REDUCTION_ORDER='Auto reduction order'
}
